import { createToaster } from "./elements/toaster/toaster-creator";
import { createTooltip } from "./elements/tooltip/tooltip-creator";
import * as liteComponents from "./komodo-assets/lite-components";
import "./komodo-assets/lite-components.css";
import "./styles.css";
import functionCallsHandler from "./utils/function-calls-handler";
var callsHandler = functionCallsHandler();
/**
 * Create a toaster element with the given options and display it on the page
 * @param {ToasterOptions} options 
 */ export var toaster = function(options) {
    if (callsHandler.functionCallExists("toaster", options.componentId)) {
        console.error("Toaster with id [".concat(options.componentId, "] already exists"));
    }
    if (options.componentId === undefined || options.componentId === null || options.componentId === "") {
        console.error("Component ID is required");
    }
    if (options.callerId === undefined || options.callerId === null || options.callerId === "") {
        console.error("Caller ID is required");
    }
    callsHandler.addFunctionCall("toaster", options.componentId);
    var createKomodoToasterInstance = function(e) {
        return new liteComponents.KomodoNotification(e);
    };
    createToaster(options, createKomodoToasterInstance);
};
/**
 * Create a tooltip element with the given options and display it on the page
 * @param {TooltipOptions} options 
 */ export var tooltip = function(options) {
    if (callsHandler.functionCallExists("tooltip", options.componentId)) {
        console.error("Tooltip with id [".concat(options.componentId, "] already exists"));
    }
    if (options.targetId === undefined || options.targetId === null || options.targetId === "") {
        console.error("Target ID is required");
    }
    if (options.componentId === undefined || options.componentId === null || options.componentId === "") {
        console.error("Component ID is required");
    }
    if (options.callerId === undefined || options.callerId === null || options.callerId === "") {
        console.error("Caller ID is required");
    }
    callsHandler.addFunctionCall("tooltip", options.componentId);
    var createKomodoTooltipInstance = function(e) {
        return new liteComponents.KomodoTooltip(e);
    };
    createTooltip(options, createKomodoTooltipInstance);
};
